import { makeStyles, tokens } from '@fluentui/react-components';

// Pinned to the same height as the rail's filter strip on the left so the
// bottom borders align across the gutter.
const TITLE_BAR_HEIGHT = '60px';

export const useStyles = makeStyles({
  root: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '0',
    overflow: 'hidden',
  },

  // ── Title bar ─────────────────────────────────────────────────────────
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalM,
    minHeight: TITLE_BAR_HEIGHT,
    boxSizing: 'border-box',
    paddingTop: '0',
    paddingRight: tokens.spacingHorizontalXL,
    paddingBottom: '0',
    paddingLeft: tokens.spacingHorizontalXL,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: tokens.colorNeutralStroke2,
  },

  // Tab strip — sits directly under the title bar, mirroring the Grader /
  // Judge Factory detail views. Pinned bottom border continues the header's.
  tabs: {
    flexShrink: '0',
    paddingRight: tokens.spacingHorizontalXL,
    paddingLeft: tokens.spacingHorizontalXL,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: tokens.colorNeutralStroke2,
  },

  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
    minWidth: '0',
    flex: '1',
  },

  name: {
    fontSize: '20px',
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    flexShrink: '0',
  },

  // ── 2-column body: form (left) + versions rail (right) ────────────────
  body: {
    flex: '1',
    display: 'flex',
    minHeight: '0',
    overflow: 'hidden',
  },

  formColumn: {
    flex: '1',
    overflowY: 'auto',
    minHeight: '0',
    minWidth: '0',
    display: 'flex',
    flexDirection: 'column',
  },

  errorText: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: tokens.fontSizeBase200,
  },

  spinnerWrap: {
    flex: '1',
    paddingTop: tokens.spacingVerticalXXL,
    paddingBottom: tokens.spacingVerticalXXL,
    display: 'flex',
    justifyContent: 'center',
  },
});
